import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useRequiredTenantPaths } from "src/core/hooks/routing/useTenantPaths";
import { ICustomDuplicateFolder, ICustomDuplicatePerson } from "src/core/interfaces/Folders";

type DuplicateFoldersListProps = {
  duplicateFolders: ICustomDuplicateFolder[] | ICustomDuplicatePerson[];
  wrapperClassName?: string;
  listClassName?: string;
  withTitle?: boolean;
};

export const DuplicateFoldersList = ({
  duplicateFolders,
  wrapperClassName = "flex flex-col ml-[30px]",
  listClassName = "flex flex-col overflow-y-auto max-h-[150px]",
  withTitle = true,
}: DuplicateFoldersListProps) => {
  const { t } = useTranslation();

  const paths = useRequiredTenantPaths();

  if (duplicateFolders.length === 0) {
    return null;
  }

  return (
    <div className={wrapperClassName}>
      {withTitle && (
        <h2
          className="flex h-30 font-light items-center"
          data-testid="potential-duplicate-folders-title"
        >
          {t("form.createClient.potentialDuplicateFolders")}
        </h2>
      )}
      <div className={listClassName}>
        {duplicateFolders.map((folder) => {
          const folderUrl = folder.id ? paths.folder(folder.id) : null;
          if (!folderUrl) return null;

          return (
            <div
              key={folder.id}
              className="duplicate-folder-card"
              data-testid={`duplicate-card-${folder.id}`}
            >
              {"raisonSociale" in folder
                ? folder.raisonSociale
                : `${folder.lastName} ${folder.firstName} - ${
                    folder.birthDate ? format(new Date(folder.birthDate), "dd/MM/yyyy") : ""
                  }`}

              <Link
                to={paths.folder(folder.id)}
                target="_blank"
                rel="noopener noreferrer"
                className="action-link"
              >
                {t("form.createClient.seeFolder")}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};
